import React from "react";

// Lightweight markdown: **bold**, *italic*, headings (##), bullets (- ), numbered, blank lines.
function renderInline(text, keyBase) {
  const nodes = [];
  const regex = /\*\*(.+?)\*\*|\*(.+?)\*|`(.+?)`/g;
  let last = 0, m, i = 0;
  while ((m = regex.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    if (m[1]) nodes.push(<strong key={`${keyBase}-b${i}`} className="font-semibold text-foreground">{m[1]}</strong>);
    else if (m[2]) nodes.push(<em key={`${keyBase}-i${i}`}>{m[2]}</em>);
    else if (m[3]) nodes.push(<code key={`${keyBase}-c${i}`} className="font-mono-tech text-primary text-[0.85em]">{m[3]}</code>);
    last = m.index + m[0].length;
    i++;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
}

export default function MarkdownLite({ text = "", className = "" }) {
  const lines = text.split("\n");
  const blocks = [];
  let list = [];
  const flush = (k) => {
    if (list.length) {
      blocks.push(<ul key={`ul-${k}`} className="list-disc pl-5 space-y-1 my-2">{list}</ul>);
      list = [];
    }
  };
  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (/^#{1,4}\s/.test(line)) {
      flush(idx);
      const t = line.replace(/^#{1,4}\s/, "");
      blocks.push(<h4 key={idx} className="font-serif-display text-lg font-semibold mt-3 mb-1 text-foreground">{renderInline(t, idx)}</h4>);
    } else if (/^[-*]\s/.test(line)) {
      list.push(<li key={idx} className="text-sm leading-relaxed">{renderInline(line.replace(/^[-*]\s/, ""), idx)}</li>);
    } else if (line.trim() === "") {
      flush(idx);
    } else {
      flush(idx);
      blocks.push(<p key={idx} className="text-sm leading-relaxed my-1.5">{renderInline(line, idx)}</p>);
    }
  });
  flush("end");
  return <div className={className}>{blocks}</div>;
}
